import { render } from "./StudentPreview.vue?vue&type=template&id=9610d264&scoped=true"
import script from "./StudentPreview.vue?vue&type=script&lang=js"
export * from "./StudentPreview.vue?vue&type=script&lang=js"

import "./StudentPreview.vue?vue&type=style&index=0&id=9610d264&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9610d264"]])

export default __exports__